module.exports = __webpack_public_path__ + "img/semimi.f6780aa5.gif";